<template>
    <v-dialog v-model="dialog" max-width="800">
        <template #activator="{ on, attrs }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card class="code-of-conduct-dialog">
            <v-app-bar flat height="56" color="#fff">
                <v-toolbar-title>위드캔복지재단 행동강령</v-toolbar-title>
                <v-spacer />
                <v-btn color="#111" text icon aria-label="닫기" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-app-bar>
            <v-divider />

            <v-card-title>
                <div class="code-of-conduct-dialog__title">위드캔복지재단 행동강령</div>
            </v-card-title>
            <v-card-text>
                <div v-for="(item, index) in items" :key="index" class="py-24">
                    <v-row class="row--sm">
                        <v-col cols="12">
                            <div class="tit tit--sm grey-1--text">
                                {{ item.name }}
                            </div>
                        </v-col>
                        <v-col cols="12">
                            <p class="page-text">
                                {{ item.text }}
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            items: [
                {
                    name: "인권과 존엄성 존중",
                    text: "우리는 모든 사람이 차별 없이 존엄하고 평등한 권리를 누릴 수 있도록 노력합니다. 사회복지 전문기관으로서 대상자의 목소리를 존중하고, 인권 침해나 불평등이 발생하지 않도록 세심하게 살핍니다.",
                },
                {
                    name: "투명성과 책임성",
                    text: "우리는 후원금과 사업 운영 전 과정을 투명하게 공개하며, 관련 정보를 정기적으로 이해관계자와 공유합니다. 외부 회계감사와 내부 평가를 통해 공정성과 책임성을 확보하고, 부적절한 관행이나 오류가 발견되면 즉시 개선합니다.",
                },
                {
                    name: "전문성과 혁신 추구",
                    text: "재단의 임직원과 봉사자는 변화하는 복지 환경에 능동적으로 대응하기 위해 전문 지식과 역량을 꾸준히 발전시키며, 혁신적인 복지 모델을 연구·도입합니다. 이를 통해 ‘사람 중심’의 지원이 이루어지도록 끊임없이 노력합니다.",
                },
                {
                    name: "공정하고 청렴한 업무 수행",
                    text: "우리는 부패, 뇌물 수수, 금품 제공 등 윤리에 어긋나는 행위를 일절 허용하지 않습니다. 업무 수행 과정에서 이해충돌이 발생하지 않도록 주의하며, 대내외 파트너와 협력할 때에도 법과 규정을 철저히 준수합니다.",
                },
                {
                    name: "연대와 협력",
                    text: "전 세계 다양한 지역사회, 정부기관, 후원자, 시민단체와의 활발한 소통을 통해 포용적인 복지 생태계를 조성해 나갑니다. 국경과 문화, 종교를 초월해 서로의 가치를 존중하며, 진정한 연대의 의미를 실천합니다.",
                },
                {
                    name: "안전과 보호",
                    text: "모든 복지사업 현장에서, 특히 아동·청소년·장애인 등 보호가 필요한 계층과 함께할 때 더욱 강화된 안전장치와 보호 조치를 마련합니다. 이를 통해 대상자의 신체적·심리적 안전을 보장하고, 건강한 환경을 유지합니다.",
                },
                {
                    name: "개인정보 및 사생활 보호",
                    text: "재단이 수집·관리하는 모든 개인정보는 관련 법령과 내부 규정에 따라 안전하게 관리됩니다. 임직원과 봉사자의 개인정보 역시 보호의 대상임을 명심하며, 불필요한 공개나 유출이 발생하지 않도록 각별히 유의합니다.",
                },
                {
                    name: "환경 보호와 지속가능성",
                    text: "우리는 지구 환경과 자원을 존중하고 아끼기 위해 사업 기획부터 실행 전반에 이르는 각 단계에서 친환경적 방식을 우선적으로 고려합니다. 미래 세대가 안전하고 건강한 삶을 누릴 수 있도록 지속 가능 경영을 실천합니다.",
                },
                {
                    name: "위반 신고와 개선",
                    text: "본 강령에 어긋나는 행위를 발견하거나 의심이 들면 즉시 재단 내부 신고 체계를 통해 보고하고, 공정한 조사를 거쳐 적절한 조치를 취합니다. 이 과정을 통해 문제점을 파악하고 제도 개선 방안을 마련하여, 재단의 윤리적 기반을 더욱 견고히 다져갑니다.",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.code-of-conduct-dialog {
    border-radius: 8px;
    &__title {
        width: 100%;
        font-size: 20px;
        font-weight: 700;
        color: var(--v-primary-base);
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-color: currentColor;
        padding: 18px 0;
    }
    .v-card {
        &__title {
            padding-bottom: 0;
        }
    }
}
@media (min-width: 768px) {
    .code-of-conduct-dialog {
        &__title {
            font-size: 28px;
            padding: 24px 0;
        }
        .v-card {
            &__title,
            &__text {
                padding-left: 80px;
                padding-right: 80px;
            }
            &__title {
                padding-top: 40px;
            }
            &__text {
                padding-bottom: 40px;
            }
        }
    }
}
</style>